import { render, staticRenderFns } from "./EstacOlavarriaFormType.vue?vue&type=template&id=4523fa92&"
import script from "./EstacOlavarriaFormType.vue?vue&type=script&lang=js&"
export * from "./EstacOlavarriaFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports